import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { V3SchoolThroughTeacherResponse } from "./queries.type";

export const teacherQueries = {
  all: () => [ApiCatalog.teacher.key] as const,
  schools: () =>
    queryOptions({
      queryKey: [...teacherQueries.all(), ApiCatalog.schoolThroughTeacher.key],
      queryFn: () =>
        api().get<V3SchoolThroughTeacherResponse>(
          ApiCatalog.schoolThroughTeacher.endpoint.replace("[id]", "me"),
        ),
    }),
};
